import { AUDIT_DEFAULT_SORT } from "~/constants/audit";

export default () => ({
  auditEntries: null,
  viewingAudit: null,
  loading: false,
  page: 0,
  sortBy: AUDIT_DEFAULT_SORT.sortBy,
  orderBy: AUDIT_DEFAULT_SORT.orderBy,
  search: "",
});
